import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import { supabase } from '../../../lib/supabase';

const WelcomeCard = () => {
  const { t } = useTranslation();
  const [data, setData] = useState({ fullName: '', azienda: '', loading: true });

  useEffect(() => {
    const getData = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data: profil } = await supabase
          .from('profili')
          .select('nome, cognome, aziende(nome_azienda)')
          .eq('id', user.id)
          .single();

        if (profil) {
          setData({
            fullName: `${profil.nome} ${profil.cognome}`,
            azienda: profil.aziende?.nome_azienda || 'Orizon AIX',
            loading: false
          });
        }
      }
    };
    getData();
  }, []);

  const currentHour = new Date().getHours();
  let greeting = 'Buongiorno';
  if (currentHour >= 12 && currentHour < 18) greeting = 'Buon pomeriggio';
  if (currentHour >= 18) greeting = 'Buonasera';

  return (
    <div className="bg-gradient-to-br from-primary via-primary/95 to-primary/90 rounded-[2rem] p-6 md:p-8 text-white shadow-xl relative overflow-hidden group border border-white/10 transition-all duration-500 hover:shadow-primary/20">
      
      {/* DINAMIČNA POZADINSKA IKONA */}
      <div className="absolute right-[-20px] top-[-20px] opacity-[0.08] pointer-events-none transition-all duration-1000 ease-in-out group-hover:scale-150 group-hover:rotate-[20deg] group-hover:opacity-[0.15]">
        <Icon name="Box" size={300} />
      </div>

      <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="flex-grow">
          
          {/* BADGE SECTION */}
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-white/10 backdrop-blur-md px-3 py-1 rounded-full border border-white/10">
              <span className="text-[9px] font-black uppercase tracking-[0.2em]">
                {data.loading ? '...' : data.azienda}
              </span>
            </div>
            <div className="flex items-center gap-2 text-emerald-400">
              <div className="relative flex h-1.5 w-1.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-500"></span>
              </div>
              <span className="text-[9px] font-black uppercase tracking-[0.2em]">DATA SYNC ACTIVE</span>
            </div>
          </div>

          {/* MAIN TITLE */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black tracking-tighter mb-2 leading-none group-hover:translate-x-1 transition-transform duration-500">
            Gestione & Inventario
          </h2>

          {/* SKRAĆENI TEHNIČKI OPIS */}
          <p className="text-white/80 text-xs md:text-sm font-medium max-w-xl leading-relaxed mb-6">
            Controllo asset, gestione ricambi e monitoraggio impianti in tempo reale. Tracciabilità completa dei movimenti logistici con sincronizzazione Cloud AIX.
          </p>

       {/* OPERATOR INFO */}
<div className="flex items-center gap-3 bg-black/15 hover:bg-black/25 transition-colors w-fit px-4 py-2.5 rounded-xl backdrop-blur-md border border-white/5 group/user">
   <div className="w-9 h-9 rounded-lg bg-gradient-to-tr from-white/20 to-white/5 flex items-center justify-center border border-white/10 group-hover/user:rotate-12 transition-transform">
      <Icon name="User" size={16} className="text-white" />
   </div>
   <div>
      {/* Popravljen tekst: Utente Autorizzato */}
      <p className="text-[8px] uppercase tracking-[0.2em] opacity-50 font-black leading-none mb-1">
         Utente Autorizzato
      </p>
      <p className="text-base font-bold tracking-tight leading-none">
        {data.loading ? '...' : `${greeting}, ${data.fullName}`}
      </p>
   </div>
</div>
        </div>

        {/* SIDE ICON */}
        <div className="hidden md:flex items-center justify-center w-32 h-32 lg:w-36 lg:h-36 rounded-[2rem] bg-white/5 backdrop-blur-xl border border-white/10 shadow-2xl relative group-hover:scale-110 group-hover:-rotate-6 transition-all duration-700">
           <Icon 
            name="Package" 
            size={50} 
            className="text-white opacity-80 group-hover:opacity-100 transition-all duration-700" 
            strokeWidth={1.5}
           />
        </div>
      </div>

   {/* FOOTER DETAIL */}
      <div className="mt-6 flex items-center justify-between w-full text-[9px] font-black uppercase tracking-[0.3em]">
          {/* Lijeva strana - Terminal ID */}
          <div className="flex items-center gap-3 opacity-30">
            <div className="w-8 h-[1px] bg-white/40" />
            <span>Orizon AIX Terminal</span>
          </div>

          {/* Desna strana - Animated Stable Connection */}
          <div className="flex items-center gap-2 bg-white/5 px-3 py-1 rounded-full border border-white/5 opacity-50 hover:opacity-100 transition-opacity duration-500">
            <span className="relative flex h-1.5 w-1.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-40"></span>
              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-500/60"></span>
            </span>
            <span className="text-emerald-400/80 font-bold tracking-[0.2em]">Database Connected</span>
          </div>
      </div>
        </div>
  );
};

export default WelcomeCard;